/**
 * M 端全站 INP：营销弹窗关闭时先同步隐藏 UI，再让业务脚本做后续逻辑
 * - 不 preventDefault / stopPropagation，不拦截事件，避免丢埋点
 * - 300 券包「首次关闭 → 挽留层」不隐藏根节点，仅快速隐藏主内容区
 */
(function () {
  if (window.innerWidth >= 768) return;

  var HIDDEN_CLASS = "klaiyi-inp-popup-hidden";

  function defer(fn) {
    if (window.KlaiyiUtils && window.KlaiyiUtils.deferAfterInteraction) {
      window.KlaiyiUtils.deferAfterInteraction(fn);
    } else if (typeof requestIdleCallback === "function") {
      requestIdleCallback(fn, { timeout: 200 });
    } else {
      setTimeout(fn, 0);
    }
  }

  function stopCountdownIn(root) {
    if (!root || !window.AlterDownTime || typeof window.AlterDownTime.stop !== "function") {
      return;
    }
    var nodes = root.querySelectorAll("[data-alter-down-time]");
    for (var i = 0; i < nodes.length; i++) {
      window.AlterDownTime.stop(nodes[i]);
    }
  }

  function fastHidePopup(root) {
    if (!root || root.classList.contains(HIDDEN_CLASS)) return;
    root.classList.add(HIDDEN_CLASS);
    stopCountdownIn(root);
    defer(function () {
      root.classList.remove(HIDDEN_CLASS);
    });
  }

  function isCloseX(target) {
    return !!target.closest(".wheel-spin-box-close-x");
  }

  function isLegacyTurntableDismiss(target) {
    if (target.closest("#modal-turntable .dismissal")) return true;
    var overlay = target.closest("#modal-turntable .overlay");
    return overlay && !target.closest("#modal-turntable .popup");
  }

  function isLegacyLuckyClose(target) {
    return !!target.closest(".lucky-coupon-popup .close");
  }

  document.addEventListener(
    "click",
    function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      if (isLegacyTurntableDismiss(target) || isLegacyLuckyClose(target)) {
        var legacy =
          target.closest("#modal-turntable") ||
          target.closest(".lucky-coupon-popup") ||
          target.closest(".lucky-coupon-center");
        fastHidePopup(legacy);
        return;
      }

      var wheel = target.closest(".sunber-wheel-poupop-con");
      if (wheel) {
        if (isCloseX(target) || !target.closest(".wheel-poupop")) {
          fastHidePopup(wheel);
        }
        return;
      }

      var allVoucher = target.closest(".all-voucher-package-con");
      if (allVoucher) {
        if (isCloseX(target) || !target.closest(".all-voucher-package")) {
          fastHidePopup(allVoucher);
        }
        return;
      }

      var three = target.closest(".three-hundred-voucher-package-con");
      if (three) {
        var closing = isCloseX(target) || !target.closest(".three-hundred-voucher-package");
        if (!closing) return;
        var joinUs = sessionStorage.getItem("threeHundredVoucherPackageJoinUsAlter");
        var stayDone = sessionStorage.getItem("threeHundredVoucherPackageStayContainerCon");
        if (joinUs === "true" || stayDone) {
          fastHidePopup(three);
        } else {
          var mainPanel = three.querySelector(".container-con");
          var closeBtn = three.querySelector(".wheel-spin-box-close-x");
          if (mainPanel) mainPanel.classList.add(HIDDEN_CLASS);
          if (closeBtn) closeBtn.classList.add(HIDDEN_CLASS);
          stopCountdownIn(three);
        }
        return;
      }

      var quiz = target.closest(".predict-win-quiz-con");
      if (quiz) {
        if (
          target.closest(".predict-win-quiz-close") ||
          !target.closest(".predict-win-quiz-modal")
        ) {
          fastHidePopup(quiz);
        }
        return;
      }

      var newCustomer = target.closest(".new-customer-global-pop-up");
      if (newCustomer) {
        if (
          target.closest(".n-c-g-popup__close") ||
          !target.closest(".n-c-g-popup")
        ) {
          fastHidePopup(newCustomer);
        }
      }
    },
    { capture: true, passive: true }
  );
})();
